import { useQuery } from '@tanstack/react-query';

import type { Product } from '@setvi/shared/interfaces';
import { getProductAssetsQuery } from 'Services/Query/Products';

interface UseProductAssetsProps {
  product: Product;
}

/** The product's documents from revops-api, keyed by SKU like the Setvi call. */
export const useProductAssets = ({ product }: UseProductAssetsProps) => {
  // `isInitialLoading`, not `isLoading`: a product without a SKU disables the
  // query, and in React Query v4 a disabled query with no data still reports
  // `isLoading`, which would show the loader forever. Background refetches
  // keep showing the cached rows.
  const { data, isInitialLoading } = useQuery(
    getProductAssetsQuery(product.sku)
  );

  return {
    documents: data?.documents ?? [],
    isLoading: isInitialLoading
  };
};
